/**
 * TwoFABanner — Iter-110 · Item 2.
 * One-time dismissible push banner inviting leadership (CEO / Directors /
 * Managers — roles admin & company_manager) to enable 2FA. Field staff
 * never see it (backend gates via /api/auth/2fa/status → show_admin_banner).
 * Dismissed permanently on Enable Now OR Dismiss.
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const TwoFABanner = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/api/auth/2fa/status`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d?.show_admin_banner) setShow(true); })
      .catch(() => {});
  }, []);

  const dismiss = () => {
    setShow(false);
    fetch(`${API}/api/auth/2fa/banner-dismiss`, { method: 'POST', credentials: 'include' }).catch(() => {});
  };

  if (!show) return null;

  return (
    <div
      className="px-4 sm:px-6 py-3"
      style={{
        background: 'linear-gradient(135deg, rgba(201,169,98,0.22) 0%, rgba(201,169,98,0.08) 100%)',
        borderBottom: '1px solid #C9A962',
      }}
      data-testid="twofa-admin-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3 flex-wrap">
        <ShieldCheck className="h-5 w-5 flex-shrink-0" style={{ color: '#C9A962' }} />
        <p className="text-xs sm:text-sm text-white flex-1 min-w-[220px]">
          <span className="font-bold" style={{ color: '#C9A962' }}>Protect your leadership account.</span>{' '}
          Two-Factor Authentication is now available — enable it from Account Settings in under a minute.
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => { dismiss(); navigate('/profile'); }}
            className="text-[11px] font-black uppercase tracking-wider px-3.5 py-1.5 rounded-full transition hover:opacity-90"
            style={{ backgroundColor: '#C9A962', color: '#1a1a1a' }}
            data-testid="twofa-banner-enable"
          >
            Enable Now
          </button>
          <button
            type="button"
            onClick={dismiss}
            className="text-[11px] font-semibold uppercase tracking-wider px-3.5 py-1.5 rounded-full transition hover:opacity-80 inline-flex items-center gap-1"
            style={{ backgroundColor: 'transparent', color: '#e5e5e5', border: '1px solid rgba(255,255,255,0.35)' }}
            data-testid="twofa-banner-dismiss"
          >
            <X className="h-3 w-3" /> Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default TwoFABanner;
